const Spacer = () => <span>&emsp;</span>;
/* eslint-enable */
export default Spacer;
